/**
 * ATENEA — <moldeamos-sticky-atc>
 *
 * Barra fija de compra en móvil. Sin dependencias: se apoya en
 * IntersectionObserver (mostrar solo cuando el botón principal de
 * compra sale del viewport) y en el pub/sub de Trade
 * ('variant-change') para reflejar precio y disponibilidad.
 * El submit lo hace el <form> real del producto (atributo form=""),
 * así que no duplica lógica de carrito.
 */

if (!customElements.get('moldeamos-sticky-atc')) {
  customElements.define(
    'moldeamos-sticky-atc',
    class MoldeamosStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.buttonEl = this.querySelector('[data-sticky-button]');

        this.moneyFormatter = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: this.dataset.currency || 'COP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        // Mostrar la barra solo cuando el botón principal no está a la vista.
        const mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (mainButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.toggleAttribute('hidden', entry.isIntersecting);
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          this.observer.observe(mainButton);
        } else {
          this.removeAttribute('hidden');
        }

        // Reaccionar al cambio de variante (pub/sub de Trade).
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const { sectionId, variant } = event.data || {};
            if (sectionId !== this.sectionId) return;
            this.updateFromVariant(variant);
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (typeof this.unsubscribeVariant === 'function') this.unsubscribeVariant();
      }

      updateFromVariant(variant) {
        const strings = window.variantStrings || {};
        if (!variant) {
          this.buttonEl.setAttribute('disabled', '');
          this.buttonEl.textContent = strings.unavailable || 'No disponible';
          if (this.priceEl) this.priceEl.textContent = '';
          return;
        }

        if (this.priceEl) {
          this.priceEl.textContent = this.moneyFormatter.format(variant.price / 100);
        }

        if (variant.available) {
          this.buttonEl.removeAttribute('disabled');
          this.buttonEl.textContent = strings.addToCart || 'Agregar al carrito';
        } else {
          this.buttonEl.setAttribute('disabled', '');
          this.buttonEl.textContent = strings.soldOut || 'Agotado';
        }
      }
    }
  );
}
